var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-data"},[_c('p',{staticClass:"mb-0"},[_vm._v("Không có dữ liệu")])])
}]

export { render, staticRenderFns }